export const MAX_ITEMS_RULE_NAME = "max_items";
/**
 * Validates that an array does not have more than a maximum number of items.
 */
export const Validator = {
    name: MAX_ITEMS_RULE_NAME,
    errorMessage: `This array field may not have more than :${MAX_ITEMS_RULE_NAME} items.`,
    validate: (value, requirement) => Array.isArray(value) && value.length <= Number(requirement),
};
